import React from 'react';
import './result.scss';

const PaymentFailed: React.FC = () => {
    // Get query parameters
    const queryParams = new URLSearchParams(window.location.search);
    const errorMessage = queryParams.get('error') || 'Your payment could not be processed.';

    return (
        <div className="payment-result-page failed">
            <header className="page-header">
                <div className="logo-container">
                    <img src="/logo-white.svg" alt="Korean Mate Logo" className="header-logo" />
                </div>
            </header>

            <div className="result-container">
                <div className="result-icon failed">
                    <svg viewBox="0 0 24 24" width="64" height="64">
                        <circle cx="12" cy="12" r="11" fill="#F44336" stroke="white" strokeWidth="2" />
                        <path d="M8 8l8 8M16 8l-8 8" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </div>

                <h1 className="result-title">Payment Failed</h1>
                
                <div className="result-details">
                    <p className="result-message">
                        {errorMessage}
                    </p>
                    
                    <div className="troubleshooting">
                        <h2>Common Issues</h2>
                        <ul>
                            <li>Your card was declined by the issuing bank</li>
                            <li>Insufficient funds in your account</li>
                            <li>Incorrect card information was provided</li>
                            <li>The transaction was flagged as suspicious by your bank</li>
                        </ul>
                    </div>

                    <div className="help-info">
                        <h2>Need Help?</h2>
                        <p>
                            If you continue to experience issues, please contact our support team at
                            <a href="mailto:support@koreanmate.app"> support@koreanmate.app</a>.
                        </p>
                    </div>
                </div>

                <div className="action-buttons">
                    <a href="/product/korean-session" className="retry-button">
                        Try Again
                    </a>
                    <a href="/" className="home-button">
                        Return to Home
                    </a>
                </div>
            </div>
        </div>
    );
};

export default PaymentFailed;